import React, { useState, useRef } from 'react';
import Image from 'next/image';
import styles from '../styles/River.module.css';
import SectionHeader from "../widgets/SectionHeader";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import * as LIB from '../lib/common';
import { filterProtectedContent, useLoginStatus } from '../lib/protectedContent';

const River = ({ data }) => {
    //Home Page River component
    const [isLoggedIn] = useLoginStatus();
    const visibleData = filterProtectedContent(data, isLoggedIn);

    const renderFirstItem = (data) => {
        //left side item, with an image.
        return (
            <Col xs={12} md={6} lg={4} className={`${styles.colum}`}>
                <a href={LIB.getBasepath(`/posts/${data.id}/` + encodeURIComponent(data.title.replace(/ /g, '')))}>
                    <div className={styles.card}>
                        <div className={styles.imgHolder}>
                            <Image
                                src={data.thumbnail}
                                alt="圖片"
                                sizes="100vw"
                                height={0}
                                width={0}
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                }}
                            />
                        </div>
                        <Container fluid >
                            <Row>
                                <Col className={styles.titleColum}>
                                    <div className={styles.bottomArea}>
                                        <div className={styles.title}>{data.title}</div>
                                        <div className={styles.excerpt}>{data.excerpt}</div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className={styles.infoRow}>
                                <Col className={styles.fullColum}><div className={styles.date}>{data.post_date.substring(0, 10)}</div></Col>
                                <Col className={styles.fullColum}>
                                    <div className={styles.category}>栽</div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </a>
            </Col>
        );
    }

    const renderRiverRow = (data) => {
        //right side river row items
        if (data) {
            return (
                data.map((data, index) => (
                    <a href={LIB.getBasepath(`/posts/${data.id}/` + encodeURIComponent(data.title.replace(/ /g, '')))} key={index} className={styles.link}>
                        <div className={styles.riverRow}>
                            <Container className={styles.riverContainer}>
                                <Row className={styles.row}>
                                    <Col xs={1} className={styles.riverRowLabelHolder}>
                                        <div className={styles.riverRowLabel}>栽</div>
                                    </Col>
                                    <Col className={styles.fullColum}>
                                        <div className={styles.riverRowContent}>
                                            <div className={styles.riverRowTitle}>
                                                {data.title}
                                            </div>
                                            <div className={styles.riverRowDate}>
                                                {data.post_date.substring(0, 10)}
                                            </div>
                                            <div className={styles.riverRowExcerpt}>
                                                {data.excerpt}
                                            </div>
                                            <div className={styles.riverRowTag}>
                                                詳細資料
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </a>
                ))
            );
        }
    }

    if (visibleData && visibleData.length > 0) {
        let firstRow = visibleData[0];
        let secondRow = visibleData.slice(1, 3).filter(Boolean);
        let thirdRow = visibleData.slice(3, 5).filter(Boolean);
        let class4colum = `d-none d-lg-block d-xl-block ${styles.colum}`;

        //render river component
        return (
            <div className={`viewport ${styles.river}`} id='river'>
                <SectionHeader title={"栽在溪水旁"} path={'/topics/02a/栽在溪水旁'} />
                <Container fluid>
                    <Row>
                        {/*first item with image, left*/}
                        {firstRow && renderFirstItem(firstRow)}

                        {/*other item, right*/}
                        <Col lg={4} md={6} className={`${styles.colum}`} >
                            <div className={styles.riverHolder}>
                                {renderRiverRow(secondRow)}
                            </div>
                        </Col>
                        <Col lg={4} className={`${class4colum}`}>
                            <div className={styles.riverHolder}>
                                {renderRiverRow(thirdRow)}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );

    }
    else {
        return (<></>);
    }
}

export default River;